import React from 'react';
import cx from 'classnames';
import {
  useStyles,
} from './styles';

interface HistoryChipProps {
  color?: string;
  children?: React.ReactNode;
}
export const HistoryChip: React.FC<HistoryChipProps> = ({ color, children }) => {
  const styles = useStyles({ color });
  return (
    <div className={cx(styles.historyChipWrapper, 'historyChipBackground')}>
      {color && (
        <span className={styles.dot} />
      )}
      <span>{children}</span>
    </div>
  );
};
